module.exports = __webpack_public_path__ + "img/4.cd06c044.png";